import Vue from 'vue'

const usePublishModal = () => {
  const store = Vue.observable({
    active: false,
    docName: '',
    cert: '',
    certPass: '',
    error: {
      shown: false,
      message: ''
    }
  })

  const setActiveModal = (status) => {
    store.active = status
    if (!status) {
      store.error.message = ''
      store.error.shown = false
    }
  }

  const resetModalState = () => {
    store.active = false
    store.docName = ''
    store.cert = ''
    store.certPass = ''
    store.error = {
      shown: false,
      message: ''
    }
  }

  return {
    store,
    setActiveModal,
    resetModalState
  }
}

export default usePublishModal
